import {
  FETCH_INIT,
  FETCHED,
  FETCHED_FAIL,
  SET_SORTING,
  SET_FILTER,
  CHANGE_PAGE,
  SET_SERVER_PAGE,
  SET_ROW_SIZE,
  CLEAN_PROGRAM_DOCTOR,
} from "../actions/ProgramDoctor.action";

function mapPresetPRequest(all, pageId, rowsPerPage = 10) {
  return all.filter((val, index) => {
    if (
      index >= (pageId + 1) * rowsPerPage - rowsPerPage &&
      index < (pageId + 1) * rowsPerPage
    ) {
      return val;
    }
  });
}

const initialState = {
  all: [],
  present: [],
  currentPage: 0,
  serverPage: 0,
  query: null,
  query_data: null,
  sorting_data: { row: null, order: null },
  is_fetching: false,
  rowsPerPage: 10,
  // true once the program is known to have at least one mydoc code, so the
  // block is not hidden when a search comes back empty
  has_records: false,
};

export default function (
  state = JSON.parse(JSON.stringify(initialState)),
  action
) {
  switch (action.type) {
    case FETCH_INIT: {
      return { ...state, is_fetching: true };
    }
    case FETCHED: {
      const newData = action.payload.data || [];
      const page = action.payload.page;
      let newAll = [];
      if (page == 1) {
        newAll = [...newData];
      } else {
        // guard against the same slab coming back twice, which would otherwise
        // duplicate rows in the table
        const loadedIds = new Set(state.all.map((val) => val?.id || val?.code));
        newAll = [
          ...state.all,
          ...newData.filter((val) => !loadedIds.has(val?.id || val?.code)),
        ];
      }
      const tableData = mapPresetPRequest(
        newAll,
        state.currentPage,
        state.rowsPerPage
      );
      return {
        ...state,
        all: newAll,
        present: tableData,
        is_fetching: false,
        has_records: state.has_records || newAll.length > 0,
      };
    }
    case FETCHED_FAIL: {
      return { ...state, is_fetching: false };
    }
    case SET_SORTING: {
      return { ...state, sorting_data: action.payload };
    }
    case SET_FILTER: {
      return {
        ...state,
        query: action.payload.query,
        query_data: action.payload.query_data,
      };
    }
    case CHANGE_PAGE: {
      const tempPage = action.payload;
      const tableData = mapPresetPRequest(
        state.all,
        tempPage,
        state.rowsPerPage
      );
      return { ...state, present: tableData, currentPage: tempPage };
    }
    case SET_SERVER_PAGE: {
      return { ...state, serverPage: action.payload };
    }
    case SET_ROW_SIZE: {
      const present = mapPresetPRequest(state.all, 0, action.payload);
      return { ...state, rowsPerPage: action.payload, present, currentPage: 0 };
    }
    case CLEAN_PROGRAM_DOCTOR: {
      return JSON.parse(JSON.stringify(initialState));
    }
    default: {
      return state;
    }
  }
}
